module.exports = __webpack_public_path__ + "img/polygon.85ea6bf6.png";